/**
 * @file
 *
 * Adds the legacy odd-row class used to style striped frontend tables.
 */

$(document).ready(function(){
	$('table').each(function(){
		var curTable = $(this);

		if (curTable.is('.striped')) {
			curTable.find('tbody').children(':even').each(function(){
				$(this).addClass('odd');
			});
		}
	});
});
